module.exports = __webpack_public_path__ + "img/pijltjes-header-desktop.6102ee0b5ef7e2d315875caccdb88ae1.svg";